export default __webpack_public_path__ + "static/media/skapaforkortning3.c3cf655a.png";